export default () => {
  const userStore = useUserStore();
  const facilityStore = useFacilityStore();
  const careDayStore = useCareDayStore();

  userStore.$reset();
  facilityStore.$reset();
  careDayStore.$reset();
};
